"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextEditor = void 0;
var _react = _interopRequireDefault(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _DOM = require("../../Utils/DOM");
var _Range = require("../../Utils/Range");
var _TextEditorStateProvider = require("./TextEditorStateProvider");
var _excluded = ["fontItem", "color"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TextEditor = exports.TextEditor = /*#__PURE__*/function (_React$Component) {
  _inherits(TextEditor, _React$Component);
  var _super = _createSuper(TextEditor);
  function TextEditor() {
    var _this;
    _classCallCheck(this, TextEditor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      contentHTML: ''
    });
    _defineProperty(_assertThisInitialized(_this), "selectionChangeListener", function () {
      var editorContent = _this.contentRef.current;
      var selection = window.getSelection();
      var node;
      if (selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        var endContainer = range.endContainer;
        var parentNode = endContainer.parentNode;
        node = parentNode;
      }
      if (node && node.children && node.children.length > 0) {
        if (Object.values(node.children).filter(function (element) {
          return element.nodeName.toLowerCase() !== 'br';
        }).length === 0) {
          return;
        }
      }
      if (editorContent.childElementCount === 0 && editorContent.innerText !== '') {
        _this.wrapSingleTextNodeWithStyle(editorContent);
      }

      // check if the target node is inside the editor
      if (node && editorContent.contains(node)) {
        _this.updateCurrentFormatting(node);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateCurrentFormatting", function () {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.getStyleSourceNode();
      if (!node.innerText) {
        return;
      }
      var rootElement = _this.contentRef.current;
      var _this$props = _this.props,
        onUpdateCurrentStyle = _this$props.onUpdateCurrentStyle,
        textEditorState = _this$props.textEditorState;

      // get the formatting
      var currentFormatting = _objectSpread(_objectSpread({}, _this.getNodeFormatting(node)), _this.props.explicitStyleParams);
      // when there are 0 span's currentFormatting would take defaultcolor and would update currentStyle with default
      // can't skip update as it might affect font family update so required to consider currentStyle color.
      if (rootElement.innerText.trim() === '') {
        var currentStyle = textEditorState.currentStyle;
        textEditorState && textEditorState.updateDefaultStyle && textEditorState.updateDefaultStyle({
          color: currentStyle.color
        });
        currentFormatting.color = currentStyle.color;
      }
      onUpdateCurrentStyle && onUpdateCurrentStyle(currentFormatting);
      textEditorState && textEditorState.updateCurrentStyle && textEditorState.updateCurrentStyle(currentFormatting);
    });
    _defineProperty(_assertThisInitialized(_this), "initTextEditorContent", function () {
      // init text editor content
      var _this$props2 = _this.props,
        content = _this$props2.content,
        autoFocusWhenMounted = _this$props2.autoFocusWhenMounted;
      var unwrappedContent = _this.unwrapContent(content);
      var input = _this.contentRef.current;
      if (input.innerHTML !== unwrappedContent) {
        input.innerHTML = unwrappedContent;
        if (!input.children.length && autoFocusWhenMounted) {
          _this.focusToEnd();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "focusToEnd", function () {
      var editorContent = _this.contentRef.current;
      editorContent.focus();
      // set the cursor to the end of the text
      var selection = window.getSelection();
      if (selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        var lastEndNode = (0, _DOM.getLastEndNode)(editorContent);
        range.setStart(lastEndNode, lastEndNode.textContent.length);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (evt) {
      var disableLinebreaks = _this.props.disableLinebreaks;
      if (disableLinebreaks && evt.keyCode === 13) {
        evt.preventDefault();
      }
      // prevent direct line-breaks
      // it inserts a <br> tag which can lead to wrong structure
      if (evt.keyCode === 13 && evt.shiftKey) {
        evt.preventDefault();
      } else if (evt.keyCode === 66 && evt.ctrlKey) {
        // bold
        _this.formatDoc('bold');
        evt.preventDefault();
      } else if (evt.keyCode === 73 && evt.ctrlKey) {
        // italic
        _this.formatDoc('italic');
        evt.preventDefault();
      } else if (evt.keyCode === 85 && evt.ctrlKey // ctrl + u // not supported yet
      ) {
        evt.preventDefault();
      }
      evt.stopPropagation();
    });
    _defineProperty(_assertThisInitialized(_this), "onPaste", function () {
      setTimeout(function () {
        var container = _this.contentRef.current;
        var defaultStyle = (0, _get["default"])(_this.props, 'textEditorState.defaultStyle', {});
        var disableLinebreaks = _this.props.disableLinebreaks;
        (0, _DOM.updatePastedTextNode)(container, disableLinebreaks);
        var divs = _toConsumableArray(container.childNodes);
        divs.forEach(function (div) {
          div.dataset && _this.setNodeData(div, 'color', defaultStyle.color.identifier);
          if (div.childElementCount === 0 && div.textContent.trim() !== '') {
            var spanEle = document.createElement('SPAN');
            spanEle.innerText = div.textContent;
            div.textContent = '';
            div.appendChild(spanEle);
          }
          if (div.childElementCount > 0) {
            div.firstChild.style.color = defaultStyle.color.value;
            div.firstChild.dataset && _this.setNodeData(div.firstChild, 'color', defaultStyle.color.identifier);
          }
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updateContent", function () {
      var htmlElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.contentRef.current;
      var wrappedContent = _this.wrapContentWithDefaultStyle(htmlElement);
      var value = wrappedContent.outerHTML;
      if (_this.state.contentHTML !== value) {
        _this.setState({
          contentHTML: value
        });
        var onChangeHTML = _this.props.onChangeHTML;
        onChangeHTML && onChangeHTML(wrappedContent);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "contentRef", _this.props.rteRef || /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "getSelectedNodes", function () {
      var selectAllIfEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var forceSelectAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var updateSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (window.getSelection) {
        var editorContent = _this.contentRef.current;
        var sel = window.getSelection();
        var range = sel.rangeCount > 0 && sel.getRangeAt(0);
        if (selectAllIfEmpty && (sel.rangeCount === 0 || sel.isCollapsed ||
        // selection length is 0
        forceSelectAll) ||
        // forced select all
        // if the selection is out of range select all is the default
        // important: IE11 does not check text nodes so the parentNode should be used
        // so the commonAncestorContainer can be the editor container itself
        !editorContent.contains(range.commonAncestorContainer.parentNode) && range.commonAncestorContainer !== editorContent) {
          var _range = (0, _Range.selectAll)(editorContent);
          if (updateSelection) {
            sel.removeAllRanges();
            sel.addRange(_range);
          }
          if (editorContent.textContent.length === 0 && _range.endOffset === 0) {
            return false;
          }
          return (0, _Range.getNodesInRange)(_range, false);
        }
        return range && (0, _Range.getNodesInRange)(range);
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "applyOnSelectedNodes", function (fn) {
      var applyOnAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var nodes = _this.getSelectedNodes(true, applyOnAll);
      var results = [];
      if (nodes) {
        nodes.forEach(function (node) {
          return results.push(fn(node));
        });
      }
      _this.updateCurrentFormatting();
      return results;
    });
    _defineProperty(_assertThisInitialized(_this), "setNodeData", function (node, name, value) {
      node.dataset[name] = value;
    });
    _defineProperty(_assertThisInitialized(_this), "getNodeData", function (node, key) {
      if (!node || !key) {
        throw new Error('Empty node or data key!');
      }
      var data = node.dataset[key];
      var root = _this.contentRef.current;
      // if there is no data, try to get it from the parent (until we find it)
      if (!data && node !== root && root.contains(node)) {
        return _this.getNodeData(node.parentNode, key);
      }
      return data;
    });
    // https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Editable_content#Example_A_simple_but_complete_rich_text_editor
    _defineProperty(_assertThisInitialized(_this), "formatDoc", function (sCmd, sValue) {
      var _this$props3 = _this.props,
        fullTextCommandList = _this$props3.fullTextCommandList,
        onChangeProp = _this$props3.onChangeProp;
      var isParagraphCommand = ['justifyLeft', 'justifyCenter', 'justifyRight'].indexOf(sCmd) !== -1;
      var value = sValue;
      var setData = false;
      if (_typeof(sValue) === 'object') {
        value = sValue.value;
        setData = true;
      }
      if (isParagraphCommand) {
        if (/^justify/.test(sCmd)) {
          var alignValue = sCmd.replace('justify', '').toLowerCase();
          // set the explicit textAlign param
          onChangeProp('textAlign', alignValue);
          return;
        } else if (document.activeElement !== _this.contentRef.current) {
          // if the active element is not the editor => select all before triggering the command
          _this.getSelectedNodes(true, true, true);
        }
      } else {
        var applyOnAll = fullTextCommandList instanceof Array && fullTextCommandList.indexOf(sCmd) > -1;
        switch (sCmd) {
          case 'fontSize':
            // change the explicit fontSize param instead of setting it on the node (needed for CI-223)
            onChangeProp('fontSize', value);
            return;
          case 'foreColor':
            _this.applyOnSelectedNodes(function (node) {
              var style = node.style;
              style.color = value;
              setData && _this.setNodeData(node, 'color', sValue.identifier);
            }, applyOnAll);
            return;
          case 'fontFamily':
            _this.applyOnSelectedNodes(function (_ref) {
              var style = _ref.style;
              return style.fontFamily = value;
            }, applyOnAll);
            return;
          case 'bold':
            {
              var isToggled = _this.applyOnSelectedNodes(function (_ref2) {
                var style = _ref2.style;
                return style.fontWeight === sCmd;
              }).indexOf(false) === -1;
              _this.applyOnSelectedNodes(function (_ref3) {
                var style = _ref3.style;
                return isToggled ? style.fontWeight = 'normal' : style.fontWeight = sCmd;
              }, applyOnAll);
              return;
            }
          case 'italic':
            {
              var _isToggled = _this.applyOnSelectedNodes(function (_ref4) {
                var style = _ref4.style;
                return style.fontStyle === sCmd;
              }).indexOf(false) === -1;
              _this.applyOnSelectedNodes(function (_ref5) {
                var style = _ref5.style;
                return _isToggled ? style.fontStyle = 'normal' : style.fontStyle = sCmd;
              }, applyOnAll);
              return;
            }
        }
      }
      document.execCommand(sCmd, false, value);
    });
    return _this;
  }
  _createClass(TextEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.initTextEditorContent();
      var editorContent = this.contentRef.current;
      this._observer = new MutationObserver(function () {
        (0, _DOM.fixContentEditableDOM)(editorContent);
        _this2.updateContent();
      });
      var config = {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      };
      this._observer.observe(editorContent, config);

      // setup content editable
      document.execCommand('defaultParagraphSeparator', false, 'div');
      document.execCommand('styleWithCSS', false, true);
      editorContent.addEventListener('keydown', this.onKeyDown);
      editorContent.addEventListener('paste', this.onPaste);
      document.addEventListener('selectionchange', this.selectionChangeListener);

      // trigger content update to synchronize the Text element with the editor settings
      this.updateContent();
      if (this.props.autoFocusWhenMounted) {
        this.focusToEnd();
      }

      // set the formatDoc function in the editor state context
      if (this.props.textEditorState) {
        this.props.textEditorState.setFormatDocFunction(this.formatDoc);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._observer.disconnect();
      var editorContent = this.contentRef.current;
      editorContent.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('selectionchange', this.selectionChangeListener);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        content = _this$props4.content,
        defaultStyle = _this$props4.textEditorState.defaultStyle,
        disableLinebreaks = _this$props4.disableLinebreaks;
      if (content && content !== prevProps.content) {
        this.setState({
          contentHTML: content
        });
        this.initTextEditorContent();
        this.updateCurrentFormatting();
      }
      if (defaultStyle !== prevProps.textEditorState.defaultStyle) {
        this.updateContent();
      }
      if (disableLinebreaks && disableLinebreaks !== prevProps.disableLinebreaks) {
        (0, _DOM.removeLinebreaks)(this.contentRef.current);
      }
    }
  }, {
    key: "wrapSingleTextNodeWithStyle",
    value: function wrapSingleTextNodeWithStyle(editorContent) {
      var _this$props$textEdito = this.props.textEditorState.currentStyle,
        fontItem = _this$props$textEdito.fontItem,
        color = _this$props$textEdito.color,
        assignableStyles = _objectWithoutProperties(_this$props$textEdito, _excluded);
      var sp = document.createElement('span');
      sp.textContent = editorContent.innerText;
      editorContent.innerText = '';
      editorContent.appendChild(sp);
      Object.assign(sp.style, _objectSpread(_objectSpread({}, assignableStyles), {}, {
        color: color.value
      }), fontItem.family && {
        fontFamily: fontItem.family
      });
      this.setNodeData(sp, 'color', color.identifier);
      (0, _DOM.placeCaretAtEnd)(sp);
    }
  }, {
    key: "getStyleSourceNode",
    value: function getStyleSourceNode() {
      var selection = window.getSelection();
      if (selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        var endContainer = range.endContainer;
        var parentNode = endContainer.parentNode;
        if (this.contentRef.current.contains(parentNode)) {
          return parentNode;
        }
      }
      return this.contentRef.current;
    }
  }, {
    key: "getNodeFormatting",
    value: function getNodeFormatting(node) {
      var endNode = (0, _DOM.getFirstEndNode)(node).parentNode;
      var _window$getComputedSt = window.getComputedStyle(endNode),
        fontSize = _window$getComputedSt.fontSize,
        fontFamily = _window$getComputedSt.fontFamily,
        fontWeight = _window$getComputedSt.fontWeight,
        fontStyle = _window$getComputedSt.fontStyle,
        textAlign = _window$getComputedSt.textAlign,
        color = _window$getComputedSt.color;
      return {
        fontSize: fontSize,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        textAlign: textAlign,
        color: {
          value: color,
          identifier: this.getNodeData(endNode, 'color')
        }
      };
    }
  }, {
    key: "unwrapContent",
    value: function unwrapContent(content) {
      var div = document.createElement('div');
      div.innerHTML = content;
      return div.children.length === 1 && div.firstChild.tagName === 'DIV' ? div.firstChild.innerHTML : div.innerHTML;
    }
  }, {
    key: "wrapContentWithDefaultStyle",
    value: function wrapContentWithDefaultStyle(editorElement) {
      var content = editorElement.innerHTML;
      var div = document.createElement('div');
      var defaultStyle = (0, _get["default"])(this.props, 'textEditorState.defaultStyle', {});
      Object.assign(div.style, _objectSpread(_objectSpread({}, defaultStyle), {}, {
        color: defaultStyle.color.value
      }));
      this.setNodeData(div, 'color', defaultStyle.color.identifier);
      div.innerHTML = content;
      return div;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        className = _this$props5.className,
        _this$props5$textEdit = _this$props5.textEditorState,
        defaultStyle = _this$props5$textEdit.defaultStyle,
        currentStyle = _this$props5$textEdit.currentStyle,
        elementProps = _this$props5.elementProps;
      var color = (0, _get["default"])(defaultStyle, 'color.value', '');
      var dataColor = (0, _get["default"])(defaultStyle, 'color.identifier', '');
      var textAlign = (0, _get["default"])(currentStyle, 'textAlign', 'left');
      return (
        /*#__PURE__*/
        // minHeight should be applied due to FF blank content editable issue
        _react["default"].createElement("div", _extends({
          className: className,
          ref: this.contentRef,
          contentEditable: true,
          style: _objectSpread(_objectSpread({}, defaultStyle), {}, {
            color: color,
            textAlign: textAlign,
            minHeight: 15
          }),
          "data-color": dataColor
        }, elementProps))
      );
    }
  }]);
  return TextEditor;
}(_react["default"].Component);
_defineProperty(TextEditor, "defaultProps", {
  autoFocusWhenMounted: true,
  disableLinebreaks: false
});
var _default = exports["default"] = (0, _TextEditorStateProvider.withTextEditorState)(TextEditor);